// Central route table + bottom-tab definitions. Screens and the router both
// import from here so paths never drift. Each mockup screen (00–20 in
// software/requirements/UI_mockup/) maps to exactly one route below.
import type { IconName } from '../ui/icons'
import type { AppWorkspace, Role } from '../api'

/** The router `handle` shape for a role-gated route GROUP (router.tsx): declaring
 *  `handle: { role }` on a pathless parent gates every child by construction —
 *  RoleGuard (Layout.tsx) reads it off the matched route, so a new gated screen is
 *  added INSIDE its group and can never be forgotten in a separate prefix list. */
export type RouteHandle =
  | { role: Role; roles?: never; workspace?: never }
  | { roles: Role[]; role?: never; workspace?: never }
  | { workspace: AppWorkspace; role?: never; roles?: never }

export const ROUTES = {
  login: '/login',
  home: '/',
  homeDetails: '/details',
  workModes: '/work-modes',
  touSchedule: '/tou-schedule',
  touWindow: '/tou-schedule/window',
  tariff: '/tariff',
  tariffPeriod: '/tariff/period',
  tariffTier: '/tariff/tier',
  flatRate: '/tariff/flat',
  tariffDemand: '/tariff/demand',
  homeEditor: '/home-editor',
  weatherStates: '/weather-states',
  history: '/history',
  batteryPack: '/battery-pack',
  inverter: '/inverter',
  deviceLink: '/device-link',
  wifiReconnect: '/wifi-reconnect',
  consent: '/consent',
  notifications: '/notifications',
  softwareUpdate: '/updates',
  admTransparency: '/adm-transparency',
  menu: '/menu',
  devices: '/devices',
  ownerAdd: '/add-device',
  ownership: '/ownership',
  security: '/security',
  batterySettings: '/battery-settings',
  manualOperations: '/manual-operations',
  installerAdd: '/installer/add',
  installerResidence: '/installer/residence',
  commissioning: '/installer/commissioning',
  diagnostics: '/installer/diagnostics',
  compliance: '/installer/compliance',
  firmware: '/installer/firmware',
  fleet: '/installer/fleet',
  installerOrganisation: '/installer/organisation',
  installerInventory: '/installer/inventory',
  installerRequests: '/installer/requests',
  admin: '/admin',
  adminPortal: '/admin/portal',
  documents: '/documents',
  supportConsole: '/support',
  supportMessages: '/support-messages',
  helpFaq: '/help/faq',
  vppPartner: '/vpp-partner',
  screens: '/screens',
} as const

export interface TabDef {
  label: string
  icon: IconName
  to: string
}

export const HOMEOWNER_TABS: TabDef[] = [
  { label: 'Home', icon: 'home', to: ROUTES.home },
  { label: 'Analytics', icon: 'chart', to: ROUTES.history },
  { label: 'Devices', icon: 'devices', to: ROUTES.devices },
  { label: 'Me', icon: 'user', to: ROUTES.menu },
]

export const INSTALLER_TABS: TabDef[] = [
  { label: 'Fleet', icon: 'devices', to: ROUTES.fleet },
  { label: 'Add', icon: 'plus', to: ROUTES.installerAdd },
  { label: 'Diagnostics', icon: 'chart', to: ROUTES.diagnostics },
  { label: 'Me', icon: 'user', to: ROUTES.menu },
]
